var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    zoomAndPan: "magnify",
    viewBox: "0 0 96 95.999999",
    height: 128,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.126389, 0, 0, 0.126389, 47.87916, 47.87158)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 350.818776 -0.00384968 C 350.818776 193.224197 193.751448 349.858833 -0.00201091 349.858833 C -193.75547 349.858833 -350.822798 193.224197 -350.822798 -0.00384968 C -350.822798 -193.231897 -193.75547 -349.866532 -0.00201091 -349.866532 C 193.751448 -349.866532 350.818776 -193.231897 350.818776 -0.00384968 Z M 350.818776 -0.00384968 ",
    stroke: "#ffffff",
    strokeWidth: 25,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.126389, 0, 0, 0.126389, 47.87916, 47.618808)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M -0.341983 -136.558165 C -0.341983 -136.558165 -132.004088 -64.48398 -132.004088 -64.48398 C -132.004088 -64.48398 -132.004088 136.53253 -132.004088 136.53253 C -132.004088 136.53253 -44.569324 136.53253 -44.569324 136.53253 C -44.569324 136.53253 -44.569324 59.080596 -44.569324 59.080596 C -44.569324 34.448038 -24.634569 14.513283 -0.00201091 14.513283 C 24.630547 14.513283 44.565303 34.448038 44.565303 59.080596 C 44.565303 59.080596 44.565303 136.53253 44.565303 136.53253 C 44.565303 136.53253 132.000067 136.53253 132.000067 136.53253 C 132.000067 136.53253 132.000067 -64.48398 132.000067 -64.48398 C 132.000067 -64.48398 -0.341983 -136.558165 -0.341983 -136.558165 Z M -0.341983 -136.558165 ",
    stroke: "#ffffff",
    strokeWidth: 31,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a38d831afad37a08be01e76d28d58c0a.svg";
export { ForwardRef as ReactComponent };